var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _g3, _path24, _path25, _g4, _path26, _path27, _g5, _path28, _g6, _path29, _g7, _path30, _path31, _path32, _g8, _path33, _path34, _g9, _path35, _path36, _g0, _path37, _g1, _path38, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampusImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 152,
    viewBox: "0 0 131 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.551 25.2645C105.129 21.7059 99.699 21.2452 95.7565 23.9494C95.485 19.3415 92.0174 15.399 87.2702 14.6995C82.7121 14.0299 78.4256 16.5606 76.6854 20.5969C75.6091 16.1625 71.5757 12.9138 66.82 13.002C61.325 13.11 56.9574 17.6525 57.0654 23.1475L57.3171 35.9317C57.4237 41.3599 61.8581 45.6877 67.2635 45.6877C67.3304 45.6877 67.3972 45.6877 67.464 45.6863C70.5989 45.6251 73.3656 44.1181 75.1456 41.8149C76.5745 44.5347 79.2374 46.5592 82.5088 47.0412C83.0007 47.1137 83.4884 47.1478 83.9704 47.1478C84.0827 47.1478 84.195 47.1435 84.3073 47.1407C84.5163 47.4094 84.7424 47.6696 84.9826 47.9198C86.9361 49.9529 89.545 50.9751 92.1581 50.9751C94.7713 50.9751 97.1242 50.0524 99.0535 48.197L108.271 39.3354C112.233 35.5265 112.357 29.2254 108.548 25.263L108.551 25.2645Z",
    fill: "#FFEDD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.205 64.5938C113.205 87.2235 91.8366 96.6482 65.4776 96.6482C39.1187 96.6482 17.75 87.2235 17.75 64.5938C17.75 41.964 39.1187 29.3433 65.4776 29.3433C91.8366 29.3433 113.205 41.964 113.205 64.5938Z",
    fill: "#FFEDD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.939 66.9056C99.939 82.8888 84.5103 90.5505 65.4776 90.5505C46.4448 90.5505 31.0161 82.8888 31.0161 66.9056C31.0161 50.9225 46.4448 43.012 65.4776 43.012C84.5103 43.012 99.939 50.9211 99.939 66.9056Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1377_27565",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 43,
    width: 69,
    height: 48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.939 66.9056C99.939 82.8888 84.5103 90.5505 65.4776 90.5505C46.4448 90.5505 31.0161 82.8888 31.0161 66.9056C31.0161 50.9225 46.4448 43.012 65.4776 43.012C84.5103 43.012 99.939 50.9211 99.939 66.9056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1257 88.1236C48.5958 88.1236 53.8408 82.8785 53.8408 76.4085C53.8408 69.9384 48.5958 64.6934 42.1257 64.6934C35.6557 64.6934 30.4106 69.9384 30.4106 76.4085C30.4106 82.8785 35.6557 88.1236 42.1257 88.1236Z",
    fill: "#B7654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8298 88.1236C95.2999 88.1236 100.545 82.8785 100.545 76.4085C100.545 69.9384 95.2999 64.6934 88.8298 64.6934C82.3598 64.6934 77.1147 69.9384 77.1147 76.4085C77.1147 82.8785 82.3598 88.1236 88.8298 88.1236Z",
    fill: "#B7654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4764 73.3008L63.4751 70.9644L65.8114 69.6294L67.4802 70.9644L66.1452 73.3008H64.4764Z",
    fill: "#AF4F3C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7141 64.7287C54.6298 66.813 51.9896 67.5537 50.0461 65.6102C48.1026 63.6667 48.8433 61.0279 50.9276 58.9423C53.0119 56.858 55.652 56.1173 57.5955 58.0608C59.539 60.0043 58.7983 62.643 56.7141 64.7287Z",
    fill: "#3B090A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7678 70.528C55.6835 72.6123 53.0434 73.353 51.0998 71.4095C49.1563 69.466 49.8971 66.8273 51.9813 64.7416C54.0656 62.6573 56.7057 61.9166 58.6493 63.8601C60.5928 65.8036 59.852 68.4423 57.7678 70.528Z",
    fill: "#3B090A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5613 62.4272C53.5832 63.4053 52.4287 63.839 51.6922 63.1025C50.9558 62.366 51.388 61.2116 52.3676 60.2334C53.3457 59.2553 54.5002 58.8217 55.2366 59.5581C55.9731 60.2946 55.5409 61.449 54.5613 62.4272Z",
    fill: "#FFF5E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.7443 69.2162C54.8571 70.1034 53.7766 70.4631 53.0401 69.7266C52.3037 68.9901 52.6634 67.9096 53.5505 67.0225C54.4377 66.1353 55.5182 65.7756 56.2547 66.5121C56.9911 67.2485 56.6314 68.329 55.7443 69.2162Z",
    fill: "#FFC160"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.164 64.5884C55.7432 65.0092 55.22 65.1671 54.846 64.7931C54.4721 64.4192 54.6299 63.8946 55.0508 63.4752C55.4716 63.0558 55.9948 62.8965 56.3687 63.2705C56.7426 63.6444 56.5848 64.169 56.164 64.5884Z",
    fill: "#B7654F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6005 71.5133C67.592 71.5133 67.5849 71.5133 67.5764 71.5133C66.8442 71.5062 66.1404 71.1508 65.4765 70.4541C64.8125 71.1508 64.1088 71.5062 63.3766 71.5133C63.3695 71.5133 63.3609 71.5133 63.3524 71.5133C62.2164 71.5133 61.5283 70.6674 61.453 70.5707C61.2127 70.2608 61.2696 69.8144 61.5795 69.5727C61.888 69.3338 62.3316 69.3878 62.5719 69.6935C62.5875 69.712 62.9102 70.0916 63.3538 70.0916C63.3595 70.0916 63.3652 70.0916 63.3709 70.0916C63.8088 70.0816 64.3107 69.7106 64.8239 69.0196C64.9575 68.8391 65.1694 68.7324 65.394 68.7324H65.5533C65.7779 68.7324 65.9897 68.8391 66.1234 69.0196C66.6366 69.7106 67.1385 70.0816 67.5764 70.0916C67.5821 70.0916 67.5878 70.0916 67.5934 70.0916C68.0456 70.0916 68.3726 69.6978 68.3754 69.6935C68.6157 69.3836 69.0607 69.3296 69.3706 69.5698C69.6805 69.8101 69.7346 70.2594 69.4943 70.5707C69.4189 70.6674 68.7308 71.5133 67.5949 71.5133H67.6005Z",
    fill: "#3B090A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9129 75.5554C83.7309 75.5554 83.5489 75.4857 83.4096 75.3478C83.1324 75.0705 83.1324 74.6198 83.4096 74.3426L86.4478 71.3044C86.7251 71.0271 87.1758 71.0271 87.453 71.3044C87.7302 71.5816 87.7302 72.0323 87.453 72.3095L84.4148 75.3478C84.2754 75.4871 84.0934 75.5554 83.9115 75.5554H83.9129Z",
    fill: "#AF4F3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7405 75.5552C87.5585 75.5552 87.3766 75.4856 87.2372 75.3477C86.96 75.0704 86.96 74.6197 87.2372 74.3425L88.9988 72.581C89.276 72.3037 89.7267 72.3037 90.0039 72.581C90.2812 72.8582 90.2812 73.3089 90.0039 73.5861L88.2424 75.3477C88.1031 75.487 87.9211 75.5552 87.7391 75.5552H87.7405Z",
    fill: "#AF4F3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5017 73.7938C89.3198 73.7938 89.1378 73.7241 88.9985 73.5862C88.7212 73.309 88.7212 72.8583 88.9985 72.581L90.2766 71.3029C90.5538 71.0257 91.0045 71.0257 91.2818 71.3029C91.559 71.5801 91.559 72.0308 91.2818 72.3081L90.0036 73.5862C89.8643 73.7255 89.6823 73.7938 89.5003 73.7938H89.5017Z",
    fill: "#AF4F3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5662 75.5554C91.3842 75.5554 91.2022 75.4857 91.0629 75.3478C90.7857 75.0705 90.7857 74.6198 91.0629 74.3426L94.1012 71.3044C94.3784 71.0271 94.8291 71.0271 95.1063 71.3044C95.3836 71.5816 95.3836 72.0323 95.1063 72.3095L92.0681 75.3478C91.9287 75.4871 91.7468 75.5554 91.5648 75.5554H91.5662Z",
    fill: "#AF4F3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3489 75.5554C36.1669 75.5554 35.985 75.4857 35.8456 75.3478C35.5684 75.0705 35.5684 74.6198 35.8456 74.3426L38.8839 71.3044C39.1611 71.0271 39.6118 71.0271 39.889 71.3044C40.1663 71.5816 40.1663 72.0323 39.889 72.3095L36.8508 75.3478C36.7115 75.4871 36.5295 75.5554 36.3475 75.5554H36.3489Z",
    fill: "#AF4F3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1761 75.5552C39.9941 75.5552 39.8121 75.4856 39.6728 75.3477C39.3955 75.0704 39.3955 74.6197 39.6728 74.3425L41.4343 72.581C41.7115 72.3037 42.1622 72.3037 42.4395 72.581C42.7167 72.8582 42.7167 73.3089 42.4395 73.5861L40.6779 75.3477C40.5386 75.487 40.3566 75.5552 40.1746 75.5552H40.1761Z",
    fill: "#AF4F3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9363 73.7938C41.7543 73.7938 41.5724 73.7241 41.433 73.5862C41.1558 73.309 41.1558 72.8583 41.433 72.581L42.7112 71.3029C42.9884 71.0257 43.4391 71.0257 43.7163 71.3029C43.9936 71.5801 43.9936 72.0308 43.7163 72.3081L42.4382 73.5862C42.2989 73.7255 42.1169 73.7938 41.9349 73.7938H41.9363Z",
    fill: "#AF4F3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0022 75.5556C43.8203 75.5556 43.6383 75.4859 43.4989 75.348C43.2217 75.0708 43.2217 74.6201 43.4989 74.3429L46.5372 71.3046C46.8144 71.0274 47.2651 71.0274 47.5424 71.3046C47.8196 71.5818 47.8196 72.0325 47.5424 72.3098L44.5041 75.348C44.3648 75.4874 44.1828 75.5556 44.0008 75.5556H44.0022Z",
    fill: "#AF4F3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1377_27565",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 13,
    width: 55,
    height: 30
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.523 42.9406L108.273 39.3351C112.236 35.5263 112.36 29.2252 108.551 25.2628C105.129 21.7042 99.699 21.2435 95.7565 23.9477C95.485 19.3398 92.0174 15.3974 87.2702 14.6979C82.7121 14.0282 78.4256 16.5589 76.6854 20.5952C75.6091 16.1623 71.5757 12.9136 66.82 13.0018C61.325 13.1098 56.9574 17.6522 57.0654 23.1473L57.1962 29.7754C59.8862 29.4882 62.6529 29.3432 65.4778 29.3432C81.6174 29.3432 95.8859 34.0761 104.523 42.9406Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5792 15.5371C60.4335 35.2793 95.5689 46.1556 112 28.6981L114.447 48.773L46.0029 39.2843L56.5792 15.5371Z",
    fill: "#FFDEBE"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2931 59.2683C76.8253 59.2681 73.8215 60.9515 72.1526 64.9568C75.1565 65.9579 76.4915 66.6255 78.5611 68.5848",
    stroke: "#3B090A",
    strokeWidth: 2.33632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4752 70.1968C63.8991 70.1968 64.2428 70.5405 64.2428 70.9644C64.2428 71.2618 64.3674 71.7938 64.6341 72.2383C64.9022 72.6852 65.1967 72.8669 65.4777 72.8669C65.9244 72.8669 66.2063 72.6303 66.4182 72.2065C66.6434 71.7561 66.7126 71.2136 66.7126 70.9644C66.7126 70.5405 67.0563 70.1968 67.4803 70.1968C67.9042 70.1968 68.2479 70.5405 68.2479 70.9644C68.2479 71.3828 68.1503 72.1753 67.7914 72.8931C67.4193 73.6374 66.6998 74.4021 65.4777 74.4021C64.4237 74.4021 63.7169 73.6938 63.3176 73.0282C62.9167 72.3601 62.7075 71.557 62.7075 70.9644C62.7075 70.5405 63.0512 70.1968 63.4752 70.1968Z",
    fill: "#3B090A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4868 64.7772C73.9331 64.1097 77.1595 62.9541 80.8308 63.6217",
    stroke: "#3B090A",
    strokeWidth: 2.33632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4672 111.658C71.8949 118.278 68.4821 119.584 66.2634 121.101C64.0446 122.619 63.6887 124.49 64.3746 126.768C65.3681 130.067 68.5187 130.853 70.7964 130.167C76.0849 128.575 85.7129 119.645 85.1619 114.7C85.5742 112.626 85.4371 110.665 85.0625 109.088C84.8749 108.299 84.6109 107.534 84.2729 106.848C83.9926 106.279 83.4522 105.326 82.5086 104.597C80.6262 103.143 77.9213 103.49 76.4672 105.372C74.4886 107.934 76.4672 108.338 76.4672 111.658Z",
    fill: "#946555"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2394 115.435C100.261 106.369 91.4472 102.088 86.6624 101.081L76.8408 121.857C80.9961 124.753 94.2174 124.501 97.2394 115.435Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 101,
    width: 22,
    height: 23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2394 115.435C100.261 106.369 91.4472 102.088 86.6624 101.081L76.8408 121.857C80.9961 124.753 94.2174 124.501 97.2394 115.435Z",
    fill: "#946555"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.315 132.535C108.547 133.183 113.314 129.465 113.962 124.233C114.609 119 110.892 114.233 105.659 113.585C100.426 112.938 95.6592 116.655 95.0118 121.888C94.3643 127.121 98.0816 131.888 103.315 132.535Z",
    fill: "#F46940"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2001 99.2865C76.1611 99.2352 76.1514 99.2226 76.1774 99.248C74.477 97.5846 74.486 93.5624 77.0108 91.8619C79.5355 90.1614 81.3651 91.0598 83.0655 92.7232C86.5764 96.1575 88.075 102.749 86.7351 107.631C86.0293 110.202 84.3109 112.373 81.5997 113.776C79.4872 114.87 78.7335 112.636 77.64 110.524C76.5466 108.412 75.5276 107.22 77.64 106.126C78.3108 105.779 78.3865 105.503 78.4281 105.352L78.4284 105.351C78.5193 105.02 78.5423 104.374 78.2592 103.361C77.9863 102.385 77.5126 101.372 77.0108 100.512C76.6111 99.8265 76.3031 99.4218 76.2001 99.2865Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 90,
    width: 14,
    height: 25
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2001 99.2865C76.1611 99.2352 76.1514 99.2226 76.1774 99.248C74.477 97.5846 74.486 93.5624 77.0108 91.8619C79.5355 90.1614 81.3651 91.0598 83.0655 92.7232C86.5764 96.1575 88.075 102.749 86.7351 107.631C86.0293 110.202 84.3109 112.373 81.5997 113.776C79.4872 114.87 78.7335 112.636 77.64 110.524C76.5466 108.412 75.5276 107.22 77.64 106.126C78.3108 105.779 78.3865 105.503 78.4281 105.352L78.4284 105.351C78.5193 105.02 78.5423 104.374 78.2592 103.361C77.9863 102.385 77.5126 101.372 77.0108 100.512C76.6111 99.8265 76.3031 99.4218 76.2001 99.2865Z",
    fill: "#946555"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1388 94.7602C84.3717 95.4076 89.1387 91.6903 89.7862 86.4574C90.4336 81.2244 86.7163 76.4574 81.4834 75.81C76.2504 75.1626 71.4834 78.8798 70.836 84.1128C70.1885 89.3457 73.9058 94.1127 79.1388 94.7602Z",
    fill: "#F46940"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9298 106.948C72.8135 105.826 74.9923 107.726 75.6253 108.311C77.3732 109.924 80.0981 109.815 81.7115 108.067C83.3249 106.319 83.2158 103.594 81.4679 101.981C77.6002 98.4107 72.8492 96.7543 69.2855 98.0585C66.8041 98.9666 64.3335 100.353 63.0772 103.87C62.277 106.11 63.8314 109.072 65.9969 110.057C68.1208 111.022 70.906 109.027 71.9298 106.948Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 97,
    width: 21,
    height: 14
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9298 106.948C72.8135 105.826 74.9923 107.726 75.6253 108.311C77.3732 109.924 80.0981 109.815 81.7115 108.067C83.3249 106.319 83.2158 103.594 81.4679 101.981C77.6002 98.4107 72.8492 96.7543 69.2855 98.0585C66.8041 98.9666 64.3335 100.353 63.0772 103.87C62.277 106.11 63.8314 109.072 65.9969 110.057C68.1208 111.022 70.906 109.027 71.9298 106.948Z",
    fill: "#946555"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7398 118.181C63.9728 118.828 68.7398 115.111 69.3872 109.878C70.0347 104.645 66.3174 99.8781 61.0845 99.2307C55.8515 98.5832 51.0845 102.3 50.4371 107.533C49.7896 112.766 53.5069 117.533 58.7398 118.181Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 103,
    width: 22,
    height: 28
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4677 111.657C71.8954 118.277 68.4826 119.583 66.2639 121.101C64.0451 122.619 63.6892 124.49 64.3751 126.767C65.3685 130.067 68.5192 130.853 70.7968 130.167C76.0854 128.574 85.7134 119.645 85.1624 114.7C85.5747 112.625 85.4376 110.665 85.063 109.088C84.8754 108.298 84.6114 107.534 84.2734 106.848C83.9931 106.279 83.4527 105.325 82.5091 104.597C80.6267 103.142 77.9218 103.49 76.4677 105.372C74.4891 107.933 76.4677 108.338 76.4677 111.657Z",
    fill: "#946555"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.273 140.09C68.506 140.738 73.273 137.021 73.9204 131.788C74.5679 126.555 70.8506 121.788 65.6177 121.14C60.3847 120.493 55.6177 124.21 54.9703 129.443C54.3228 134.676 58.0401 139.443 63.273 140.09Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 90,
    width: 14,
    height: 25
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2001 99.2865C76.1611 99.2352 76.1514 99.2226 76.1774 99.248C74.477 97.5846 74.486 93.5624 77.0108 91.8619C79.5355 90.1614 81.3651 91.0598 83.0655 92.7232C86.5764 96.1575 88.075 102.749 86.7351 107.631C86.0293 110.202 84.3109 112.373 81.5997 113.776C79.4872 114.87 78.7335 112.636 77.64 110.524C76.5466 108.412 75.5276 107.22 77.64 106.126C78.3108 105.779 78.3865 105.503 78.4281 105.352L78.4284 105.351C78.5193 105.02 78.5423 104.374 78.2592 103.361C77.9863 102.385 77.5126 101.372 77.0108 100.512C76.6111 99.8265 76.3031 99.4218 76.2001 99.2865Z",
    fill: "#946555"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.5289 112.791C86.7377 104.329 79.3589 99.5694 75.3296 98.0583C83.3886 101.08 85.4785 107.88 87.4176 103.725C86.2844 110.398 84.3201 121.252 85.5289 112.791Z",
    fill: "#8B5C4D"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0323 111.658C58.6046 118.278 62.0174 119.584 64.2361 121.101C66.4549 122.619 66.8108 124.49 66.1249 126.768C65.1315 130.067 61.9808 130.853 59.7032 130.167C54.4146 128.575 44.7866 119.645 45.3376 114.7C44.9253 112.626 45.0624 110.665 45.437 109.088C45.6246 108.299 45.8886 107.534 46.2266 106.848C46.5069 106.279 47.0473 105.326 47.9909 104.597C49.8733 103.143 52.5782 103.49 54.0323 105.372C56.0109 107.934 54.0323 108.338 54.0323 111.658Z",
    fill: "#946555"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2601 115.435C30.2381 106.369 39.0523 102.088 43.8372 101.081L53.6587 121.857C49.5034 124.753 36.2821 124.501 33.2601 115.435Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 101,
    width: 22,
    height: 23
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2601 115.435C30.2381 106.369 39.0523 102.088 43.8372 101.081L53.6587 121.857C49.5034 124.753 36.2821 124.501 33.2601 115.435Z",
    fill: "#946555"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.185 132.535C21.952 133.183 17.185 129.465 16.5376 124.233C15.8901 119 19.6074 114.233 24.8404 113.585C30.0733 112.938 34.8403 116.655 35.4877 121.888C36.1352 127.121 32.4179 131.888 27.185 132.535Z",
    fill: "#F46940"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2994 99.2865C54.3385 99.2352 54.3481 99.2226 54.3221 99.248C56.0225 97.5846 56.0135 93.5624 53.4887 91.8619C50.964 90.1614 49.1344 91.0598 47.434 92.7232C43.9232 96.1575 42.4245 102.749 43.7644 107.631C44.4702 110.202 46.1886 112.373 48.8998 113.776C51.0123 114.87 51.7661 112.636 52.8595 110.524C53.9529 108.412 54.972 107.22 52.8595 106.126C52.1887 105.779 52.113 105.503 52.0714 105.352L52.0711 105.351C51.9802 105.02 51.9572 104.374 52.2403 103.361C52.5132 102.385 52.9869 101.372 53.4887 100.512C53.8884 99.8265 54.1964 99.4218 54.2994 99.2865Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 90,
    width: 13,
    height: 25
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2994 99.2865C54.3385 99.2352 54.3481 99.2226 54.3221 99.248C56.0225 97.5846 56.0135 93.5624 53.4887 91.8619C50.964 90.1614 49.1344 91.0598 47.434 92.7232C43.9232 96.1575 42.4245 102.749 43.7644 107.631C44.4702 110.202 46.1886 112.373 48.8998 113.776C51.0123 114.87 51.7661 112.636 52.8595 110.524C53.9529 108.412 54.972 107.22 52.8595 106.126C52.1887 105.779 52.113 105.503 52.0714 105.352L52.0711 105.351C51.9802 105.02 51.9572 104.374 52.2403 103.361C52.5132 102.385 52.9869 101.372 53.4887 100.512C53.8884 99.8265 54.1964 99.4218 54.2994 99.2865Z",
    fill: "#946555"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3612 94.7602C46.1283 95.4076 41.3613 91.6903 40.7138 86.4574C40.0664 81.2244 43.7837 76.4574 49.0166 75.81C54.2496 75.1626 59.0166 78.8798 59.664 84.1128C60.3115 89.3457 56.5942 94.1127 51.3612 94.7602Z",
    fill: "#F46940"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5697 106.948C57.686 105.826 55.5072 107.726 54.8742 108.311C53.1263 109.924 50.4014 109.815 48.788 108.067C47.1747 106.319 47.2837 103.594 49.0316 101.981C52.8993 98.4107 57.6504 96.7543 61.214 98.0585C63.6955 98.9666 66.166 100.353 67.4223 103.87C68.2225 106.11 66.6681 109.072 64.5026 110.057C62.3787 111.022 59.5935 109.027 58.5697 106.948Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 97,
    width: 21,
    height: 14
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5697 106.948C57.686 105.826 55.5072 107.726 54.8742 108.311C53.1263 109.924 50.4014 109.815 48.788 108.067C47.1747 106.319 47.2837 103.594 49.0316 101.981C52.8993 98.4107 57.6504 96.7543 61.214 98.0585C63.6955 98.9666 66.166 100.353 67.4223 103.87C68.2225 106.11 66.6681 109.072 64.5026 110.057C62.3787 111.022 59.5935 109.027 58.5697 106.948Z",
    fill: "#946555"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7597 118.181C66.5267 118.828 61.7597 115.111 61.1123 109.878C60.4648 104.645 64.1821 99.8781 69.4151 99.2307C74.648 98.5832 79.415 102.3 80.0624 107.533C80.7099 112.766 76.9926 117.533 71.7597 118.181Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 103,
    width: 22,
    height: 28
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0319 111.657C58.6041 118.277 62.0169 119.583 64.2357 121.101C66.4544 122.619 66.8103 124.49 66.1244 126.767C65.131 130.067 61.9803 130.853 59.7027 130.167C54.4141 128.574 44.7861 119.645 45.3371 114.7C44.9248 112.625 45.0619 110.665 45.4365 109.088C45.6241 108.298 45.8882 107.534 46.2261 106.848C46.5064 106.279 47.0468 105.325 47.9904 104.597C49.8728 103.142 52.5777 103.49 54.0319 105.372C56.0104 107.933 54.0318 108.338 54.0319 111.657Z",
    fill: "#946555"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1377_27565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2265 140.09C61.9935 140.738 57.2265 137.021 56.5791 131.788C55.9316 126.555 59.6489 121.788 64.8819 121.14C70.1148 120.493 74.8818 124.21 75.5292 129.443C76.1767 134.676 72.4594 139.443 67.2265 140.09Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1377_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 90,
    width: 13,
    height: 25
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2994 99.2865C54.3385 99.2352 54.3481 99.2226 54.3221 99.248C56.0225 97.5846 56.0135 93.5624 53.4887 91.8619C50.964 90.1614 49.1344 91.0598 47.434 92.7232C43.9232 96.1575 42.4245 102.749 43.7644 107.631C44.4702 110.202 46.1886 112.373 48.8998 113.776C51.0123 114.87 51.7661 112.636 52.8595 110.524C53.9529 108.412 54.972 107.22 52.8595 106.126C52.1887 105.779 52.113 105.503 52.0714 105.352L52.0711 105.351C51.9802 105.02 51.9572 104.374 52.2403 103.361C52.5132 102.385 52.9869 101.372 53.4887 100.512C53.8884 99.8265 54.1964 99.4218 54.2994 99.2865Z",
    fill: "#946555"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1377_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.9706 112.791C43.7618 104.329 51.1406 99.5694 55.1699 98.0583C47.1109 101.08 45.021 107.88 43.0819 103.725C44.2151 110.398 46.1794 121.252 44.9706 112.791Z",
    fill: "#8B5C4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1377_27565",
    x: 73.7844,
    y: 92.3579,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1377_27565",
    x: 49.6086,
    y: 54.5827,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1377_27565",
    x: 29.2097,
    y: 78.0034,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1377_27565",
    x: 33.7429,
    y: 99.9131,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1377_27565",
    x: -4.68973,
    y: 92.3579,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1377_27565",
    x: 19.4865,
    y: 54.5827,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1377_27565",
    x: 39.885,
    y: 78.0034,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1377_27565",
    x: 35.3518,
    y: 99.9131,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_1377_27565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampusImg2);
export default __webpack_public_path__ + "static/media/campusImg2.55539ad062c384801d5fd8e627811ff2.svg";
export { ForwardRef as ReactComponent };